import { keyframes } from '@emotion/react';
import styled from '@emotion/styled';

const spinKeyFrames = keyframes`
    0% {
		transform: rotate(0deg);
	}
	100% {
		transform: rotate(360deg);
	}
`;

export const Spin = styled.div`
  transform: translate(-50%, -50%);
  display: flex;
  align-items: center;
  width: 40px;
  height: 40px;
  margin: auto;
  border: 6px solid RGB(40, 198, 171);
  border-radius: 50%;
  border-top: 6px solid #dddddd;
  -webkit-animation: spin 2s linear infinite;
  /* Safari */
  animation: ${spinKeyFrames} 2s linear infinite;
`;

export const Container = styled.div`
  position: fixed;
  display: flex;
  align-items: center;
  width: 100vw;
  height: 100vh;
  background: #ffffff;
  z-index: 100;
`;
